var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCmf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.917,
    height: 28.609,
    viewBox: "0 0 55.917 28.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2021",
    "data-name": "Grupo 2021",
    transform: "translate(-583.204 -435.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2646",
    "data-name": "Rect\\xE1ngulo 2646",
    width: 55.917,
    height: 28.609,
    rx: 2,
    transform: "translate(583.204 435.44)",
    fill: "#13a438"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo_CMF",
    "data-name": "Logo CMF",
    transform: "translate(588.141 441.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6512",
    "data-name": "Grupo 6512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6510",
    "data-name": "Grupo 6510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2259",
    "data-name": "Trazado 2259",
    d: "M35.35,31.088A7.887,7.887,0,0,1,43.439,23a7.8,7.8,0,0,1,6.714,3.678l-3.436,1.972a3.619,3.619,0,0,0-3.279-1.773,3.961,3.961,0,0,0-4.145,4.21A3.961,3.961,0,0,0,43.439,35.3a3.593,3.593,0,0,0,3.279-1.8L50.153,35.5a7.772,7.772,0,0,1-6.714,3.679A7.887,7.887,0,0,1,35.35,31.088Z",
    transform: "translate(-35.35 -23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2260",
    "data-name": "Trazado 2260",
    d: "M294.313,43.483h-3.945V35.129L286.6,41.355h-.4l-3.746-6.2v8.332H278.49V27.97h3.967L286.4,34.6l3.967-6.626h3.945V43.483Z",
    transform: "translate(-262.267 -27.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2261",
    "data-name": "Trazado 2261",
    d: "M556.517,31.8v2.526h5.451v3.834h-5.451v5.318H552.55V27.97h9.529V31.8h-5.563Z",
    transform: "translate(-518.042 -27.638)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6511",
    "data-name": "Grupo 6511",
    transform: "translate(44.288 12.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2262",
    "data-name": "Trazado 2262",
    d: "M701.944,218.523a1.657,1.657,0,0,1-2.824-1.192,1.585,1.585,0,0,1,.518-1.21,1.628,1.628,0,0,1,1.143-.451,1.665,1.665,0,0,1,1.162,2.853Zm-2.139-2.155a1.378,1.378,0,0,0,.007,1.942,1.359,1.359,0,0,0,1.936,0,1.344,1.344,0,0,0,.4-.978,1.329,1.329,0,0,0-.4-.962,1.346,1.346,0,0,0-1.944,0Zm.247,1.887v-1.842h.512c.227,0,.354,0,.38,0a.888.888,0,0,1,.363.095.464.464,0,0,1,.245.44.406.406,0,0,1-.129.336.6.6,0,0,1-.319.123.628.628,0,0,1,.262.106.5.5,0,0,1,.162.413v.165a.358.358,0,0,0,0,.054.268.268,0,0,0,.013.054l.017.052h-.46a1.33,1.33,0,0,1-.031-.255.844.844,0,0,0-.031-.226.225.225,0,0,0-.136-.135.554.554,0,0,0-.165-.029l-.106-.007h-.1v.651Zm.879-1.479a.809.809,0,0,0-.28-.038h-.117v.534h.187a.448.448,0,0,0,.263-.067.251.251,0,0,0,.095-.219A.21.21,0,0,0,700.932,216.776Z",
    transform: "translate(-699.12 -215.67)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCmf);
export default __webpack_public_path__ + "static/media/logo-cmf.4b53822eb4ef11aa692f3d83ec5e9e82.svg";
export { ForwardRef as ReactComponent };